import { useEffect }            from 'react';
import { store }                from 'index';
import { groupUrl }             from 'utils/constants'
import { GET_TOTAL_LIKES_SAGA } from 'actions';

const useGetTotalLikes = (guest: boolean) => {

    useEffect(() => {
      if (groupUrl || guest) { return; }
        store.dispatch(GET_TOTAL_LIKES_SAGA());
    },[guest])


}
export default useGetTotalLikes;

